/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Ověření platby`
};

const da_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Betaling gennemgås`
};

const de_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Zahlungsüberprüfung`
};

const en_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Payment review`
};

const es_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Revisión de pago`
};

const fr_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Vérification du paiement`
};

const hu_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Fizetés ellenőrzése`
};

const it_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Verifica pagamento`
};

const nl_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Betaling controleren`
};

const pl_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Weryfikacja płatności`
};

const pt_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Revisão de pagamento`
};

const sv_order_states_payment_review = /** @type {(inputs: {}) => string} */ () => {
	return `Betalningsgranskning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_states_payment_review = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_states_payment_review(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_states_payment_review", locale)
	if (locale === "cs") return cs_order_states_payment_review(inputs)
	if (locale === "da") return da_order_states_payment_review(inputs)
	if (locale === "de") return de_order_states_payment_review(inputs)
	if (locale === "en") return en_order_states_payment_review(inputs)
	if (locale === "es") return es_order_states_payment_review(inputs)
	if (locale === "fr") return fr_order_states_payment_review(inputs)
	if (locale === "hu") return hu_order_states_payment_review(inputs)
	if (locale === "it") return it_order_states_payment_review(inputs)
	if (locale === "nl") return nl_order_states_payment_review(inputs)
	if (locale === "pl") return pl_order_states_payment_review(inputs)
	if (locale === "pt") return pt_order_states_payment_review(inputs)
	return sv_order_states_payment_review(inputs)
};
export { order_states_payment_review as "order_states.payment_review" }